// QuoteSection.js
import React from "react";
import { motion } from "framer-motion";

export const Quote = () => {
  return (
    <div className="bg-stone-800 py-10">
      <motion.h1
        className="text-2xl md:text-5xl text-center font-quattrocento text-stone-100 max-w-6xl mx-auto px-4"
        whileInView={{ y: 0, opacity: 1 }}
        initial={{ y: -30, opacity: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 1.2 }}
      >
        "En genuin italiensk restaurang som lyfter fram de mest älskade smakerna
        och traditionerna från Italiens främsta kulinariska regioner."
      </motion.h1>
    </div>
  );
};
